<div container-principal>
    <header>
        <button (click)="cancelarAlteracoes()">
            <object data="assets\agview-connect\Arrow-left.svg" type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.ARROW" | transloco }}</object>
        </button>
        <object data="assets\agview-connect\alert.svg" type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.ALERT" | transloco }}</object>
        <span class="font-12"><b>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.TITLE" | transloco }}</b></span>
    </header>
    <article class="w-100 d-flex justify-content-center flex-column gp-05">
        <span class="w-100">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.INSTRUCTION" | transloco }}</span>
        <div  class="container-senha">
            <span class="font-09">C:</span>
            <span class="font-09 cor-verde"> {{senhaAtual}}</span>
        </div>
        <div class="w-100 d-flex container-input">
            <input #input class="w-100" [type]="tipoCampo" [placeholder]="'COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.PASSWORD_LABEL' | transloco">
            <button (click)="alternarTipoCampo()">
                <img #imgSenha class="img-senha" src="assets\agview-connect\visivel.png" alt="">
            </button>
        </div>
        <span *ngIf="senhaIncorreta" class="senha-incorreta" >{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.WRONG_PASSWORD" | transloco }}</span>
    </article>
    <footer class="d-flex w-100 gp-05">
        <button class="btn-voltar" (click)="cancelarAlteracoes()" >
            <object data="assets\agview-connect\cancel.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.CANCEL" | transloco }}</span>
        </button>
        <button (click)="validarSenha()">
            <object data="assets\agview-connect\check.svg" type="image/svg+xml">Check</object>
            <span>{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_IMPLEMENTO.MODAL_AUTENTICACAO.VALIDATE" | transloco }}</span>
        </button>
    </footer>
</div>